export default __webpack_public_path__ + "static/media/estrutura2.cc34db8b.jpg";